
let handlers = {
    getAccessToken: async () => { throw new Error('AUTH_NOT_WIRED'); },
    refreshSilently: async () => { throw new Error('AUTH_NOT_WIRED'); },
    logout: async () => {}
};

export function registerAuthHandlers(partial) {
    handlers = { ...handlers, ...partial };
}

export async function getAccessToken() {
    return handlers.getAccessToken();
}
export async function refreshSilently() {
    return handlers.refreshSilently();
}
export async function logout() {
    return handlers.logout();
}
